// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddFollowUpButton_modal__3zp70"};